__turbopack_context__.v({
  "image": "ProductCardAlt-module-scss-module__jBln1G__image",
  "name": "ProductCardAlt-module-scss-module__jBln1G__name",
  "originalPrice": "ProductCardAlt-module-scss-module__jBln1G__originalPrice",
  "price": "ProductCardAlt-module-scss-module__jBln1G__price",
  "productCard": "ProductCardAlt-module-scss-module__jBln1G__productCard",
  "productInfo": "ProductCardAlt-module-scss-module__jBln1G__productInfo",
  "productLink": "ProductCardAlt-module-scss-module__jBln1G__productLink",
  "salePrice": "ProductCardAlt-module-scss-module__jBln1G__salePrice",
});
